import React from 'react';
import BunkeringPageHeader from './BunkeringPageHeader';
import { BunkeringContainerStyle } from './Bunkering.styles';
import { useBunkerContext } from 'src/context/BunkerContext';
import BunkerRobContainer from './bunker-rob-page/BunkerRobContainer';
import { BunkeringPageTabs } from './BunkeringUtils';
import BunkeringRegistrationContainer from './bunker-registration/BunkerRegistrationContainer';

const BunkeringContainer: React.FC = () => {
    const { selectedBunkeringTab, setSaveBunkeringPageData } = useBunkerContext();

    const onSaveData = () => {
        setSaveBunkeringPageData(true);
    };

    return (
        <BunkeringContainerStyle>
            <BunkeringPageHeader onSaveReport={onSaveData} />
            {selectedBunkeringTab === BunkeringPageTabs.rob && <BunkerRobContainer />}
            {selectedBunkeringTab === BunkeringPageTabs.registration && <BunkeringRegistrationContainer />}
        </BunkeringContainerStyle>
    );
};

export default BunkeringContainer;
